export var defaultProps = {
  color: "background",
  shadow: "none",
  borderWidth: 2,
  borderRadiusSize: "large",
  display: "block"
};